import { Component, OnInit, ViewChild }                             from '@angular/core';
import { FormControl, FormGroupDirective, NgForm, Validators }      from '@angular/forms';
import { ErrorStateMatcher }                                        from '@angular/material/core';
import { Router, ActivatedRoute }                                   from '@angular/router';
import { first }                                                    from 'rxjs/operators';
import * as jsPDF                                                   from 'jspdf'
import * as html2canvas                                             from 'html2canvas';
import { NgxSpinnerService }                                        from 'ngx-spinner';

import { AlertService, ProctorService }                             from '../_services';
import { Globals }                                                  from '../_helpers';


export class MyErrorStateMatcher implements ErrorStateMatcher {
    isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        const isSubmitted = form && form.submitted;
        return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
    }
}

@Component({
    selector: 'app-report',
    templateUrl: './report.component.html',
    styleUrls: ['./report.component.css']
})


export class ReportComponent implements OnInit {

    statusMsg: string = '';
    localData = {};
    localBatch = {};
    localStudent = {};
    localExam = {};
    loading = false;
    submitted = false;
    returnUrl: string;
    condidateImgSrc: string = '';
    studentData = [];

    student_name: string = '';
    student_mobile: string = '';
    studentImg: string = '';
    batch_name: string = '';
    exam_name: string = '';
    assessor_name: string = '';
    locations: string = '';
    exam_date;
    totalScorePer = 0.0;
    training_parter;
    training_center;
    total_time;
    exam_start_time;

    overall_result = [];
    question_answer = [];
    student_images = [];

    public doughnutChartLabels:string[] = ['marks','total'];
    public doughnutChartData:number[] = [75, 25];
    public doughnutChartType:string = 'doughnut';
    public doughnutChartOption = {
        scaleShowVerticalLines: false,
        responsive: true
    };

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private proctorService: ProctorService,
        private alertService: AlertService,
        private globals: Globals,
        private spinner: NgxSpinnerService
    ) {}

  	ngOnInit() {
        this.globals.prevRoute = '/students';
        this.localData = JSON.parse(localStorage.getItem('currentUser'));
        this.localBatch = JSON.parse(localStorage.getItem('localBatch'));
        this.localStudent = JSON.parse(localStorage.getItem('localStudent'));
        this.localExam = JSON.parse(localStorage.getItem('localExam'));

        if(this.localData['is_report'] != 1)
            this.router.navigateByUrl('/login');

        this.studentReport();
  	}


    public studentReport(){
        this.spinner.show();
        this.proctorService.getStudentsExamReport(this.globals.root_url, this.localData['usercode'], this.localStudent['student_id'], this.localExam['exam_id'], this.localBatch['batchId'])
          .pipe(first())
          .subscribe(
            data => {
                if(data.code == 1000){
                    this.totalScorePer = (data.totalScorePer).toFixed(2);
                    this.student_name = data.student_name;
                    this.student_mobile = data.student_mobile;
                    this.studentImg = data.student_photo;
                    this.batch_name = this.localBatch['batch_name'];
                    this.exam_date = data.exam_date;
                    this.exam_name = data.exam_name;
                    this.assessor_name = data.assessor_name;
                    this.locations = data.locations;
                    this.overall_result = data.overall_result;
                    this.question_answer = data.question_answer;
                    this.student_images = data.student_images;
                    this.training_parter = data.training_parter;
                    this.training_center = data.training_center;
                    this.total_time = data.total_time;
                    this.exam_start_time = data.exam_start_time;
                }
                else if(data.status == 'COM_TOKEN_ERROR'){
                    this.loading = false;
                    this.router.navigateByUrl('/login');
                }
                else{
                    this.loading = false;
                    this.globals.statusOpen(data.status);
                }
                this.spinner.hide();
            },
            error => {
                this.alertService.error(error);
                this.loading = false;
                this.spinner.hide();
            }
        );
    }

    public reportSavePDF() {
        this.spinner.show();
        var data = document.getElementById('report');
        html2canvas(data, {allowTaint : false , useCORS: true, logging: true}).then(canvas => {
            // Few necessary setting options
            var imgWidth = 201;
            var pageHeight = 280;
            var imgHeight = (canvas.height * imgWidth / canvas.width) - 10;
            var heightLeft = imgHeight;
            /*let src = canvas.getAttribute('src');
            canvas.setAttribute('crossorigin', 'anonymous')*/
            const contentDataURL = canvas.toDataURL()
            let pdf = new jsPDF('p', 'mm', 'a4');
            var position = 5;
            var mleft = 5;

            pdf.setFontSize(12);
            pdf.addImage(contentDataURL, 'PNG', mleft, position, imgWidth, imgHeight)
            heightLeft -= pageHeight;
            while (heightLeft >= 0) {
                position = heightLeft - imgHeight;
                pdf.addPage();
                pdf.setFontSize(12);
                pdf.addImage(contentDataURL, 'PNG', mleft, position, imgWidth, imgHeight);
                heightLeft -= pageHeight;
            }
            let pdfname = this.student_name+'-'+this.exam_name+'-'+this.localExam['exam_id'];
            pdf.save(pdfname+'.pdf');
            this.spinner.hide(); 
        });
    }

    // events
    public chartClicked(e:any):void {
        console.log(e);
    }
 
    public chartHovered(e:any):void {
        console.log(e);
    }

    public reportPrint(){
        window.print();
    }
}


